@use "../../../variables.scss";

.content {
  @media screen and (max-width: variables.$bp-small) {
    max-width: 100vw;
  }
}

.sub {
  z-index: 9999;
  min-width: max-content;
  background: var(--color-surfaces-bg-elevation-2);
  border-radius: 0.4rem;
  padding: 0.4rem;

  @media screen and (max-width: variables.$bp-small) {
    &[data-side='left'] {
      transform: translate(
          calc(var(--radix-dropdown-menu-trigger-width)),
          calc(var(--radix-dropdown-menu-trigger-height) - 1rem)
      );
    }

    &[data-side='right'] {
      transform: translate(
          calc(-1 * var(--radix-dropdown-menu-trigger-width)),
          calc(var(--radix-dropdown-menu-trigger-height) - 1rem)
      );
    }
  }
}

.menu {
  opacity: 2;
  min-width: 18rem;
  border-radius: 0.6rem;
  padding: 0.4rem;
  z-index: calc(var(--layer-modal) + 1);
  box-shadow: rgba(0, 0, 0, 0.2) 0 4px 24px;
  backdrop-filter: blur(10px) saturate(190%) contrast(70%) brightness(80%);
  background-color: rgba(29, 30, 43, 0.498);

  &[data-size='free-size'] {
    min-width: unset;
  }
}

.slot {
  margin-left: auto;
  padding-left: 2rem;
  color: var(--color-grey-6);
}
